<script lang="ts">
  import {Route, Router} from 'svelte5-router'
  import PoemForm from './poems/form/PoemForm.svelte'
  import {user} from './stores/user'
  import api from './api/api'
  import type {Country, Language, SubscriptionType, User} from './types'
  import Spinner from './shared/Spinner.svelte'
  import HomePage from './HomePage.svelte'
  import ExplorePage from './ExplorePage.svelte'
  import RecommendedPage from './RecommendedPage.svelte'
  import AuthRoute from './AuthRoute.svelte'
  import MyPoemsPage from './poems/MyPoemsPage.svelte'
  import FavoritePoemsPage from './poems/FavoritePoemsPage.svelte'
  import PoemPage from './poems/PoemPage.svelte'
  import ClassicsPage from './classics/ClassicsPage.svelte'
  import ClassicPage from './classics/ClassicPage.svelte'
  import UsersPage from './users/Users.svelte'
  import UserPage from './users/UserPage.svelte'
  import UserSettingsPage from './users/UserSettings.svelte'
  import UserStatisticsPage from './users/UserStatistics.svelte'
  import TagsPage from './tags/TagsPage.svelte'
  import CollectionsPage from './collections/CollectionsPage.svelte'
  import CollectionPage from './collections/CollectionPage.svelte'
  import MyCollectionsPage from './collections/MyCollectionsPage.svelte'
  import ResetPasswordPage from './ResetPasswordPage.svelte'
  import Page from './pages/Page.svelte'
  import NotFoundPage from './NotFoundPage.svelte'
  import Sidebar from './shared/Sidebar.svelte'
  import Flash from './shared/Flash.svelte'
  import TopBar from './shared/TopBar.svelte'
  import Footer from './shared/Footer.svelte'
  import Modal from './shared/Modal.svelte'
  import {settings, type Settings} from './stores/settings'
  import {staticData} from './stores/static'

  let initialized = false

  async function load() {
    [$user, $settings, staticData.countries, staticData.languages, staticData.subscriptionTypes] = await Promise.all([
      api.get<User>('/current_user').catch(() => undefined),
      api.get<Settings>('/settings'),
      api.get<Country[]>('/countries'),
      api.get<Language[]>('/languages'),
      api.get<SubscriptionType[]>('/subscription_types')
    ])

    initialized = true
  }

  load()

  const pages = ['advertise', 'about', 'help', 'privacy-policy', 'copyright-policy', 'cookies-policy', 'terms-of-service', 'ambassadors']
</script>

{#if initialized}
  <Router>
    <Sidebar/>
    <Flash/>

    <div class="pusher">
      <div class="row">
        <TopBar/>

        <Route path="/" component={HomePage}/>
        <Route path="/home" component={HomePage}/>
        <Route path="/explore" component={ExplorePage}/>
        <AuthRoute path="/recommended" component={RecommendedPage}/>
        <AuthRoute path="/poems/new">
          <PoemForm step="edit"/>
        </AuthRoute>

        <AuthRoute path="/poems/:handle/:step">
          {#snippet children(params)}
            <PoemForm handle={params.handle} step={params.step}/>
          {/snippet}
        </AuthRoute>

        <AuthRoute path="/my-poems" component={MyPoemsPage}/>
        <AuthRoute path="/favorite" component={FavoritePoemsPage}/>
        <Route path="/poems/:handle" component={PoemPage}/>
        <Route path="/poets" component={ClassicsPage}/>
        <Route path="/poets/:handle" component={ClassicPage}/>
        <Route path="/authors" component={UsersPage}/>
        <Route path="/authors/:handle" component={UserPage}/>
        <AuthRoute path="/settings" component={UserSettingsPage}/>
        <AuthRoute path="/statistics" component={UserStatisticsPage}/>
        <Route path="/tags" component={TagsPage}/>
        <Route path="/collections" component={CollectionsPage}/>
        <Route path="/collections/:id" component={CollectionPage}/>
        <AuthRoute path="/my-collections" component={MyCollectionsPage}/>

        {#each pages as page}
          <Route path="/{page}">
            <Page handle={page} />
          </Route>
        {/each}

        <Route path="/reset-password/:token" component={ResetPasswordPage}/>
        <Route path="/*" component={NotFoundPage}/>

        <Footer/>
      </div>
    </div>

    <Modal/>
  </Router>
{:else}
  <div class="spinner-container">
    <Spinner/>
  </div>
{/if}

<style>
  .spinner-container {
    position: fixed;
    display: flex;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    justify-content: center;
    align-items: center;
  }
</style>


